import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";

function AddDocumentModal({ isOpen, toggle, title, label, onSave }) {
  const [value, setValue] = useState("");

  const handleSave = () => {
    if (!value.trim()) return;
    onSave(value);
    setValue("");
    toggle();
  };

  const handleCancel = () => {
    setValue("");
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>{title}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{label}</Label>
          <Input
            placeholder={`Enter ${label.toLowerCase()}`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="default" onClick={handleSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddDocumentModal;
